import { FunctionComponent, useMemo } from 'react'
import { LatLngExpression } from 'leaflet'
import { Marker, Popup } from 'react-leaflet'
import { jobIconText, MAP_JOB_COLORS } from './map-constants'
import { MapJob } from './map-types'
import L from 'leaflet'
import { JobResume } from './job-resume'

/**
 * Properties type for JobMarker
 */
export type JobMarkerProps = {
  job: MapJob | LatLngExpression
  onJobClick?: () => void
  onOpenPopup?: (job: MapJob | LatLngExpression) => void
  onClosePopup?: () => void
  interval?: number
  timezone: string
}

export const JobMarker: FunctionComponent<JobMarkerProps> = ({
  job,
  interval = 60000,
  onJobClick = () => {},
  onOpenPopup = () => {},
  onClosePopup = () => {},
  timezone
}) => {
  const eventHandlers = useMemo(
    () => ({
      popupopen: () => {
        onOpenPopup(job)
      },
      popupclose: () => onClosePopup()
    }),
    [job, onClosePopup, onOpenPopup]
  )
  const jobIcon = `<div class='map-marker-icon map-job-icon'><image src="${jobIconText}" /></div>`
  const mapJob = job as MapJob
  const style =
    mapJob.partialStatus && MAP_JOB_COLORS[mapJob.partialStatus]
      ? `background-color: ${MAP_JOB_COLORS[mapJob.partialStatus].bg}; color: ${
          MAP_JOB_COLORS[mapJob.partialStatus].text
        };`
      : ''
  const icon = L.divIcon({
    className: 'custom-job-icon',
    html: `<div class='marker-pin marker-job' style='${style}'>${jobIcon}</div>`,
    iconSize: [30, 42],
    iconAnchor: [15, 42]
  })

  if (!job) {
    return null
  }

  if (Array.isArray(job)) {
    return <Marker position={job} icon={icon} />
  } else {
    const { location } = job as MapJob
    if (!location) {
      return null
    }
    return (
      <Marker position={location} icon={icon} eventHandlers={eventHandlers}>
        <Popup className='gungnir-job-popup' closeButton={false} offset={[0, -24]} position={location}>
          <JobResume job={job as MapJob} onJobClick={onJobClick} interval={interval} timezone={timezone} />
        </Popup>
      </Marker>
    )
  }
}
